import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { formatearNumeroConComas } from "views/Components/Shared/utils/formatNumbers";
import { useBoundStore } from "useStore";
import { useShallow } from "zustand/react/shallow";
import { memo } from "react";

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasBeenEdited",
})(({ hasBeenEdited }) => ({
  height: "calc(100% + 20px)",
  width: "calc(100% + 20px)",
  margin: "-10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: hasBeenEdited ? "2px solid #1E9BD6" : "1px solid #D2D2D2",
  backgroundColor: hasBeenEdited ? "#e4f2fe" : "transparent",
}));

const CmColumnNumberField = memo(({ id, field, prefix, suffix, row }) => {
  const cmEditedRow = useBoundStore(
    useShallow((state) => state.cmEditedRows[id]),
  );

  const fieldData = cmEditedRow?.[field];
  const rawValue =
    fieldData?.value !== undefined ? fieldData.value : row[field];

  const hasBeenEdited =
    fieldData?.valueOriginal !== undefined &&
    fieldData?.valueEdited !== undefined &&
    Number(fieldData.valueEdited) !== Number(fieldData.valueOriginal);

  const formatted =
    rawValue != null
      ? `${prefix || ""}${formatearNumeroConComas(rawValue)}${suffix || ""}`
      : "-";

  return (
    <StyledBox hasBeenEdited={hasBeenEdited}>
      <Typography
        variant="body2"
        sx={{
          color: hasBeenEdited ? "#1E9BD6" : "#9E9E9E",
          fontWeight: hasBeenEdited ? 700 : 400,
          fontSize: "14px",
        }}
      >
        {formatted}
      </Typography>
    </StyledBox>
  );
});

export default CmColumnNumberField;
